<template>
  <div class="contentGlobal">
    <div class="listContainer">
      <div class="pTop">
        <b-row>
          <b-col cols="3" class="inputSearch">
            <b-input-group>
              <!-- Type to Search -->
              <b-form-input v-model="filter" :placeholder="$t('messages.typeToSearch')"/>
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="cancelFilter()">
                  <icon name="times-circle"></icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="3" class="inputSearch">
            <select class="form-control" v-model="searchOn">
              <option
                v-for="option in searchFields"
                :key="option.value"
                v-bind:value="option.value"
                :selected="true"
              >{{ option.name }}</option>
            </select>
          </b-col>
          <b-col cols="2" class="inputSearch contBtn">
            <!-- Search -->
            <b-btn :disabled="!filter" @click="onFilter()">{{ $t("messages.search") }}</b-btn>
          </b-col>
          <b-col cols="2" class="inputSearch contBtn">
            <!-- Create new pool -->
            <!-- <router-link class="btn" :to="`/pool-new/`">{{ $t("messages.newPool") }}</router-link> -->
          </b-col>
        </b-row>
        <div>
          <b-row class="pt-4" cols="12">
            <b-table ref="table"
              class="poolTable"
              :fields="fields"
              :items="rows"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :current-page="currentPage"
              :per-page="paging.users_per_page"
              head-variant="light"
              hover striped
            >
              <template v-slot:cell(actions)="{ value, item }">
                <router-link class="btnTable"  target= '_blank' :to="`/pool-detail/${item.id}`" v-b-tooltip.hover title="Edit pool properties">
                  <icon name="edit"></icon>
                </router-link>
                <router-link class="btnTable"  target= '_blank' :to="`/detail/${item.id}`" v-b-tooltip.hover title="View pool">
                  <icon name="eye"></icon>
                </router-link>
                <b-btn v-b-tooltip.hover title="Poolcomm commands panel"
                  v-if="userProfile.isSuperAdmin"
                  :disabled="item.present == false"
                  @click="detail(item.id)"
                  class="btnTable"
                >
                  <icon name="list"></icon>
                </b-btn>
                <b-btn v-b-tooltip.hover title="Download profile"
                  v-if="userProfile.isSuperAdmin"
                  :disabled="item.present == false"
                  @click="detailProfile(item.id)"
                  class="btnTable"
                >
                  <icon name="cog"></icon>
                </b-btn>
                <b-btn v-b-tooltip.hover title="Download stats"
                  v-if="userProfile.isSuperAdmin"
                  @click="downloadStats(item.id)"
                  class="btnTable"
                >
                  <icon name="download"></icon>
                </b-btn>
              </template>

              <template #cell(present)="{ value }">
                <span v-bind:class="(value)?'green':'red'">{{ (value) ? $t("messages.yes") : $t("messages.no") }}</span>
              </template>

              <template  #cell(main.RSSI)="{ value }">
                <span v-bind:class="( getRSSI(value) )"> {{ value < 0 ? value +' dBm': 'N/A' }} </span>
              </template>

              <template #cell(createdAt)="{ value }">
                {{ value | moment("DD-MM-YYYY HH:mm:ss") }}
              </template>
              <template #cell(updatedAt)="{ value }">
                {{ value | moment("DD-MM-YYYY HH:mm:ss") }}
              </template>
            </b-table>
          </b-row>
          <b-row align-h="center">
            <el-pagination
              class="pagination"
              :page-size="paging.users_per_page"
              layout="prev, pager, next"
              :current-page="currentPage"
              :total="count"
              @current-change="handleCurrentChange"
            >
          </el-pagination>
          </b-row>
        </div>
        <modal name="view-registers" height="470" :width="570" :pivot-y="0.5" :adaptive="true" :reset="true" :clickToClose="false">
          <div class="box-modal">
            <div slot="top-right">
              <b-btn @click="$modal.hide('view-registers')" class="closePopup">
                <icon name="times-circle"></icon>
              </b-btn>
            </div>
            <el-row>
              <el-col :span="24">
                <el-row>
                </el-row>
                 <el-row>
                     <poolcomm :pool="selectedPool"></poolcomm> 
                  </el-row>
              </el-col>
            </el-row>
          </div>
        </modal>

        <modal name="view-profile" height="470" :width="570" :pivot-y="0.5" :adaptive="true" :reset="true" :clickToClose="false">
          <div class="box-modal">
            <div slot="top-right">
              <b-btn @click="$modal.hide('view-profile')" class="closePopup">
                <icon name="times-circle"></icon>
              </b-btn>
            </div>
            <el-row>
              <el-col :span="24">
                <el-row>
                </el-row>
                 <el-row>
                    <poolcommprofile :pool="selectedPool"></poolcommprofile>
                  </el-row>
              </el-col>
            </el-row>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
import poolcomm from './Poolcomm.vue'
import poolcommprofile from './Poolcomm-profile.vue'
const fb = require('../firebaseConfig.js')

  export default {
    name: 'PoolsGrid',
    components:{
      poolcomm,
      poolcommprofile
    },
    data () {
      return {
        count: null,
        filteredRegisters: [],
        search: '',
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        //currentPage: 1,
        filter: null,
        searchOn: 'id',
        rows: [],
        selectedPool: {
            registers: []
        },
        newRegisterValue: {},
        hexVal: true,
        searchFields:[
            {value: 'id', name: this.$i18n.t("messages.nodeID")},
            {value: 'form.name', name:this.$i18n.t("messages.login.name")},
            // {value: 'form.country', name:this.$i18n.t("messages.login.country")},
            // {value: 'form.city', name:this.$i18n.t("messages.city")}
        ],
        fields:
         [
            { key: "id",label: this.$i18n.t("messages.nodeID"),t: "messages.nodeID"},
            { key: 'form.name', label: this.$i18n.t("messages.login.name"), t: "messages.login.name"},
            { key: "present",label: this.$i18n.t("messages.connected"),t: "messages.connected",},
            { key: 'form.country', label: this.$i18n.t("messages.login.country"), t: "messages.login.country"},
            { key: 'form.city', label: this.$i18n.t("messages.city"), t: "messages.city"},
            { key: 'main.RSSI',label: "Wifi RSSI"},
            { key: 'createdAt', label: this.$i18n.t("messages.createdAt"), t: "messages.createdAt"},
            { key: 'updatedAt',label: this.$i18n.t("messages.updatedAt"), t: "messages.updatedAt"},
            { key: 'actions', label: this.$i18n.t("messages.actions") , t: "messages.actions"}
        ],
        paging: {
            users_per_page: 15,
            loading: false, 
            loaded: [] 
        },  
        ref: {
            rows: null, 
        }
      }
    },
    mounted() {
      window.addEventListener('keyup', this.onKeyEnter);
    },
    created() {
        const page = this.$route.query.page || 1;
        this.init();
    },
    watch: {
      "$i18n.locale": function(oldV, newV) {
        this.resetColumns();
      },
      currentPage: function(oldV, newV){
        this.onPageChange(oldV)
      }
    },
    computed: {
      ...mapState(['userProfile']),

      currentPage: {
        get() {
          return Number(this.$route.query.page) || 1;
        },
        set(newPage) {
          this.$router.push({ query: { ...this.$route.query, page: newPage } })
        }
      }
    },
    methods: {
      onKeyEnter(event){
        if (event.keyCode === 13) { 
            if(this.filter){
              this.onFilter();
            }
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
      },

      getRSSI(val) {
      var _val = Math.abs(val);
      if(_val> 0 && _val<=58){
        return "green"
      }else if(_val >58 && _val < 68){
        return "orange"
      }else if(_val >= 68){
        return "red"
      }else{
        return "grey"
      }
    },
      resetColumns() {
        this.$refs.table.fields.forEach(column => {
          if (column.t) {
            column.label = this.$i18n.t(column.t);
          }
        });
      },
      cancelFilter() {
          this.filter = null
          this.paging.loaded = []
          this.init();
      },
      onFilter() {
          this.rows = []
          if(!this.userProfile.isSuperAdmin){
             this.ref.rows  = this.ref.rows.where('company', '==', this.userProfile.company)
          }
          if(this.searchOn=='id'){
            this.filter = this.filter.toUpperCase()
          }
          //let variations=[this.filter.toUpperCase(), this.filter.toLowerCase(), this.capitalize(this.filter)];

          this.ref.rows.orderBy(this.searchOn).startAt(this.filter).endAt(this.filter+"\uf8ff").get().then ( (user) =>{
              let rows = 0
              user.forEach((doc) => {
                  let userData = doc.data();
                  userData.id = doc.id;
                  this.rows.push(userData);
                  rows++;
              });
              this.count = rows
              this.currentPage=1
          })
      },
      init () {
          if(this.userProfile.isSuperAdmin){
              fb.countersCollection.doc('pools').get().then((res) => {
                  this.count = res.data().numberOfDocs
                
                  this.rows = new Array(this.count).fill({loading: true});
                  this.ref.rows = fb.poolsCollection
                  this.onPageChange(this.currentPage);
              })
          }else{
             fb.poolsCollection.where('company', '==', this.userProfile.company).get().then((res) => {
                  this.count = res.size;
                  this.rows = new Array(this.count).fill({loading: true});
                  this.ref.rows = fb.poolsCollection
                  this.onPageChange(this.currentPage);
             })  
          }
      },
      handlePools (ref, index = 0) {
          return new Promise((resolve, reject) => {
              ref.get().then((documentSnapshots) => {
                  let _rows = [],
                  _index = index || 0;
          
                  documentSnapshots.forEach((doc) => {
                      let userData = doc.data();
                      userData.id = doc.id;
                      _rows.push(userData);
                      this.$set(this.rows, _index, {
                          loading: false,
                          ...userData
                      });
                      _index++;
                  });
                  resolve(documentSnapshots);
              });
          });
      },
      async onPageChange (toPage, fromPage) {
          const currentPage = toPage,
          per_page = this.paging.users_per_page;
          
          let startAfter = null,
              limit = per_page,
              index = per_page * (currentPage - 1),   /* Start after the pool before that page */
              startAfterAvailable;
        
          if (this.paging.loaded.includes(currentPage)) {
              return;
          };
          
          const itemBefore = this.rows[index - 1];
          if(!this.userProfile.isSuperAdmin){
              this.ref.rows = this.ref.rows.where('company', '==', this.userProfile.company)
          }
          if (itemBefore && !itemBefore.loading) {
              const itemBeforeRef = fb.poolsCollection.doc(itemBefore.id),
              itemBeforeSnapshot = await itemBeforeRef.get();
      
          
              startAfter = this.ref.rows.startAfter(itemBeforeSnapshot).limit(per_page);
              if (index < 0) {
                  index = 0;
              };
              startAfterAvailable = true;
          }
          else {
              limit = currentPage * per_page;  
              if (limit <= 0) {
                  limit = per_page;
              };
              this.ref.rows = fb.poolsCollection
              startAfter = this.ref.rows.limit(limit);
              index = 0;   /* Start loop from first page */
              startAfterAvailable = false;
          };
 
        this.handlePools(startAfter, index).then((documentSnapshots) => {
            this.paging.loading = false;
            if (startAfterAvailable) {
                this.paging.loaded.push(currentPage);
            }
            else {
                this.paging.loaded = Array.from(Array(currentPage).keys());
            };
        })
      },

      detail(poolId) {
          this.selectedPool  = this.rows.find( (pool) => {
              return pool.id === poolId
          })
          this.search = ''
          this.$modal.show('view-registers');
      },

      detailProfile(poolId) {
          this.selectedPool  = this.rows.find( (pool) => {
              return pool.id === poolId
          })
          this.search = ''
          this.$modal.show('view-profile');
      },
      downloadStats(poolId) {
          this.selectedPool  = this.rows.find( (pool) => {
              return pool.id === poolId
          })
          this.search = '';
          // var test = [{"ph":"99", "rx":"32","temp":"230", "insertAt":{"value":"223233"}},{"ph":"99", "rx":"32","temp":"230"}];
          this.$snotify.async("Generating CSV file, please be patient", () => new Promise((resolve, reject) => {
            this.$store.dispatch('getPoolStats', { pool: this.selectedPool, period: null, type:'admin'}).then(response => {
              var remap = response.data[0].map((obj) => {
              if (obj.insertAt && obj.insertAt.value) {
                obj.insertAt = obj.insertAt.value;
              }
              return obj;
            });
            if(remap && remap.length){
              var _out = this.arrayToCsv(remap);
              this.saveFile(_out);
              resolve({
              body: "CSV created correctly",
              config: {
                timeout: 1500,
                closeOnClick: true
              }
            })
            }else{
              reject({
                body: "There are no pool data associated",
                config: {
                    timeout: 2500,
                    closeOnClick: true
                }
              })
            }
         
            }, error => {
              console.log(error);
              reject({
                body: "Your request cannot be completed, please try again or contact admin site ",
                config: {
                    timeout: 2500,
                    closeOnClick: true
                }
              })
            })
          }))
      },
      capitalize(str){
        const arr = str.split(" ");
        for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        const result = arr.join(" ");
        return result;
      },
      arrayToCsv(data) {
        const array = [Object.keys(data[0])].concat(data)
        return array.map(it => {
          return Object.values(it).toString()
          }).join('\n');
      },
      saveFile(arr){
            const blob = new Blob([arr], { type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',this.selectedPool.id+'.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
      },
    },
    filters:{
      getCompanyName: (value) => {
        let companies =  [
          {code: 1, name:'Vistapool'},
          {code: 2, name:'Hayward'},
          {code: 3, name:'Naturally-salt'},
          {code: 4, name:'Da-gen'},
          {code: 5, name:'Kripsol'},
          {code: 6, name:'Brilix'}
        ]
        let val =  companies.find(x => x.code === value); 
        if(val){
            return val.name
        }  
      }
    }
};
</script>
<style> 
.pTop {
    padding-top: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pools-grid.vue